import http from "network/HTTPClient";

const SalaryPeriod = {
  async all() {
    const response = await http.post("salary_period/all");
    return response.data;
  },
  async insert(data) {
    const response = await http.post("salary_period/insert", data);
    return response.data;
  },

  async update(key, values) {
    const response = await http.post("salary_period/update", {
      id: key,
      values: values,
    });
    return response.data;
  },

  async delete(key) {
    const response = await http.post("salary_period/delete", { id: key });
    return response.data;
  },
};

export default SalaryPeriod;
